import React from 'react';

function VicePresident() {
  return (
    <section id="vicepresident" className="leader-section leader-section--navy">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title" style={{ color: '#fff' }}>
             Message from the Vice President
          </h2>
          <div className="gold-underline"></div>
        </div>
        <div className="leader-content leader-content--reverse">
          <div className="leader-message-col">
            <div className="leader-quote-icon" style={{ color: 'var(--gold)' }}>"</div>
            <blockquote style={{ color: 'rgba(255,255,255,0.95)', borderLeftColor: 'var(--gold)' }}>
              At Paramananda College of Nursing, we believe that every student holds the potential to
              become an exceptional healthcare professional. Our focus is on building clinical excellence,
              strong ethical values, and an unwavering commitment to patient care.
            </blockquote>
            <p style={{ color: 'rgba(255,255,255,0.88)' }}>
              Under our guidance, students receive not just academic knowledge but also the practical wisdom
              that comes from real-world clinical exposure. We work tirelessly to ensure that every graduate
              of PCN is a confident, competent, and compassionate nurse who makes a difference.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.88)' }}>
              Join us and be part of a journey that transforms lives — both the lives of our students
              and the patients they will serve with dedication across India and beyond.
            </p>
            <div className="leader-btns">
              <button className="btn btn-gold-outline">Read Full Message</button>
            </div>
          </div>
          <div className="leader-image-col">
            <div className="leader-photo-frame leader-photo-frame--gold">
              <img src="/vice-president.jpg" alt="Vice President Mr. Harishankar SN" className="leader-photo" />
            </div>
            <div className="leader-id-card leader-id-card--dark">
              <h3>Mr. Harishankar SN</h3>
              <p className="leader-title-tag">Vice President</p>
              <p className="leader-college-tag">Paramananda College of Nursing</p>
              <p className="leader-location-tag">📍 Bengaluru, Karnataka</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VicePresident;
